/**
 * Created by lobin on 2019/1/21.
 */
import { request } from "../../plugins/axios";
const state = {
};
const getters = {};

const actions = {
  /**
   * 获取首页相关图片---->后台管理
   * @param data
   * @return {Promise.<void>}
   */
  async getHomeImg({}, params) {
     const { data } = await request({
      url: `/portal/notice/imageList`,
      params
    });
    return data;
  },

  async getCurrentCity() {
    const { data } = await request({
     url: `https://api.ipify.org?format=json`,
   });
   console.log(data,"根据IP地址获当前位置")
   return data;
 },







};
const mutations = {
  setState(state, { key, data }) {
    state[key] = data;
  }
};
export default {
  state,
  getters,
  actions,
  mutations
};
